function gift_step1() {
  var self = this;

  this.init = function () {

    this.validateApplication();
    this.bindEvents();

    if ($('form input[type=radio][name=delivered_to]').length) {
      if ($('form input[type=radio][name=delivered_to]:checked').val() === 'recipient') {
        $("#recipient_custom_msg").show();
      } else {
        $("#recipient_custom_msg").hide();
      }
    }

  }

  this.validateApplication = function () {

    jQuery.validator.addMethod("noHTMLtags", function(value, element){
      if(/<\/?[^>]+(>|$)/g.test(value)){
          console.log(element);

          return false;
      } else {
          return true;
      }
    }, 'HTML tags are not allowed.');

    var formHasBeenSubmitted = false;

    $("#gift_step1").validate({

      ignore: ":hidden",
      onkeyup: false,

      highlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          $(element)
            .closest('.donation-group')
            .addClass('invalid');
        } else {
          $(element)
            .closest('.text-input')
            .addClass('invalid');
        }
      },

      unhighlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          var group = $(element).closest('.donation-group');

          // only mark valid if one is checked
          if ($('input[name="' + element.name + '"]:checked').length) {
            group.removeClass('invalid');
          }
        } else {
          $(element)
            .closest('.text-input')
            .removeClass('invalid');
        }
      },

      /*  ios8 & above only scroll back to the focus of the first error. If you hit submit again & there is another error
          it will not scroll. This confuses the user as they do not think there is another error message. This code fixes that. */
      invalidHandler: function(e, validator) {
        formHasBeenSubmitted = true;

        if (window.navigator.userAgent.match(/iphone/i)) {
          window.setTimeout(function() {

            var el = $(validator.errorList[0].element);

            var target = el.attr("type") === "radio"
              ? el.closest('.donation-group')
              : el;

            $("html,body").animate({
              scrollTop: target.offset().top
            });

          }, 0);
        }
      },

      errorPlacement: function(error, element) {
        error.addClass('input-error caption');

        if (element.attr("type") === "radio") {
          error.insertAfter(element.closest('.donation-group'));
        } else {
          var wrapper = element.closest('.text-input-wrapper');
          var description = wrapper.find('.input-description');

          if (description.length) {
            error.insertBefore(description);
          } else {
            wrapper.append(error);
          }
        }
      },

      rules: {
        first_name: {
          noHTMLtags: true
        },
        last_name: {
          noHTMLtags: true
        },
        recipient_first_name: {
          required: true,
          noHTMLtags: true
        },
        recipient_last_name: {
          required: true,
          noHTMLtags: true
        },
        recipient_email: {
          required: true,
        },
        recipient_msg: {
          noHTMLtags: true
        }
      },

      messages: {
        tier: {
          required: 'Select your membership type'
        },
        first_name: {
          required: 'Enter your given name'
        },
        last_name: {
          required: 'Enter your family name'
        },
        email: {
          required: 'Enter your email address',
          email: 'Enter an email address in the correct format, like name@example.com'
        },
        recipient_first_name: {
          required: 'Enter the recipients given name'
        },
        recipient_last_name: {
          required: 'Enter the recipients family name'
        },
        recipient_email: {
          required: 'Enter the recipients email address',
          email: 'Enter an email address in the correct format, like name@example.com'
        }

      },

      submitHandler: function(form) {

        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#gift_step1').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            form.submit();
          });
        });

      }

    });

  }

  this.toggle = function(className, obj) {
    var $input = $(obj);
    if ($input.prop('checked')) $(className).show();
    else $(className).hide();
  }

  this.bindEvents = function () {

    /* Show hide the recipient block */
    $("form input[type=radio][name=delivered_to]").on('click',function() {
      //self.toggle('#recipient_custom_msg', this);
      console.log($(this));
      console.log($(this).val());
      if ($(this).val() === 'recipient') {
        $("#recipient_custom_msg").show();
      } else {
        $("#recipient_custom_msg").hide();
      }
    });

     $(".text-input input").each(function () {
      var $input = $(this);
      var $field = $input.closest(".text-input");

      // INITIAL VALUE (for prefilled inputs)
      if ($input.val().length > 0) {
        $field.addClass("has-value");
      }

      // FOCUS
      $input.on("focus", function () {
        $field.addClass("focused");
      });

      // BLUR
      $input.on("blur", function () {
        $field.removeClass("focused");
      });

      // INPUT (handles typing, paste, etc.)
      $input.on("input", function () {
        if ($input.val().length > 0) {
          $field.addClass("has-value");
        } else {
          $field.removeClass("has-value");
        }
      });
    });

    $(".select-input select").each(function () {
      var $select = $(this);
      var $field = $select.closest(".select-input");

      // INITIAL VALUE
      if ($select.val() && $select.val().length > 0) {
        $field.addClass("has-value");
      }

      // CHANGE (select uses change, not input)
      $select.on("change", function () {
        if ($select.val() && $select.val().length > 0) {
          $field.addClass("has-value");
        } else {
          $field.removeClass("has-value");
        }
      });

      // OPTIONAL: focus styling consistency
      $select.on("focus", function () {
        $field.addClass("focused");
      });

      $select.on("blur", function () {
        $field.removeClass("focused");
      });
    }); 

  }

}

module.exports = gift_step1;
